/**
 * MN-8435 — Pure eligibility predicate for DTF PDP polling fallback.
 *
 * The single source of truth for "should schedulePollingFallback proceed?".
 * Lives in its own module so:
 *   - The production caller (store.schedulePollingFallback) imports it.
 *   - Unit tests target it directly, killing Stryker mutations on the
 *     gate logic without needing to drive the full Pinia store.
 *   - There is no `buildGate`/`buildStore` mirror in any test — the
 *     historical duplication that caused Mutation Testing to score store.ts
 *     at 0% (rubentorosyan-jiffy + antonzaytsev review feedback on PR #58511)
 *     is gone.
 *
 * Semantics:
 *   - DTF001 is always eligible (legacy MN-4782 path), regardless of flag.
 *   - Other catalogs in POLLING_ENABLED_CATALOG are eligible only when the
 *     server-injected flag is on.
 *   - A null catalogNumber (pre-init state) is never eligible outside the
 *     DTF001 branch.
 *   - Any catalog not in POLLING_ENABLED_CATALOG is never eligible.
 */
import { DTF001_CATALOG_NUMBER, POLLING_ENABLED_CATALOG } from "./constants";

export const isPollingEligible = (
  catalogNumber: string | null,
  dtfPollingFallbackAllCatalogs: boolean
): boolean => {
  if (catalogNumber === DTF001_CATALOG_NUMBER) return true;
  if (!dtfPollingFallbackAllCatalogs) return false;
  if (catalogNumber === null) return false;
  return POLLING_ENABLED_CATALOG.includes(catalogNumber);
};
